import { DocumentVault } from '@/pages/document/documentVault';
import type { StandardWidgetProps } from '@/models/WidgetModels';

type InvestorDocumentVaultWidgetProps = StandardWidgetProps & {
  investorId?: number;
  wealthAccountId?: number;
};

export default function InvestorDocumentVaultWidget({
  investorId,
  wealthAccountId,
  container = 'page',
}: InvestorDocumentVaultWidgetProps) {
  return (
    <DocumentVault
      investorId={investorId}
      wealthAccountId={wealthAccountId}
      container={container}
    />
  );
}
